import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { addToast, removeToast } from '../features/ui/uiSlice';

/**
 * Hook: useToast
 * Provides toast() helper to dispatch notifications from any component
 *
 * Usage:
 *   const toast = useToast();
 *   toast.success('Véhicule ajouté !');
 *   toast.error('Erreur de connexion');
 */
const useToast = () => {
  const dispatch = useDispatch();

  const show = useCallback(
    (message, type = 'success', duration = 2000) => {
      dispatch(addToast({ message, type, duration }));
    },
    [dispatch]
  );

  const dismiss = useCallback(
    (id) => dispatch(removeToast(id)),
    [dispatch]
  );

  return {
    show,
    dismiss,
    success: (msg, dur)  => show(msg, 'success', dur),
    error:   (msg, dur)  => show(msg, 'error',   dur),
    info:    (msg, dur)  => show(msg, 'info',     dur),
    warning: (msg, dur)  => show(msg, 'warning',  dur),
  };
};

export default useToast;
